<template>
    <div class="eventDetails_area" :key="eventIsUpdate" v-if="event != null">
        <!--<div class="back_icon" @click="eventDetailsBack()" v-if="isEventDetailsBackDisplay()"></div>-->

        <div class="eventDetails_header_area " v-if="isEventDetailsBackDisplay()">
            <div class="header_action_icon back_icon" @click="eventDetailsBack()"></div>
            <div class="header_text">
                <span></span>
            </div>
            <div class="header_action_icon"></div>
        </div>

        <div class="eventDetails_area_content">

            <div class="event_info_area" :class="{'isSticky pane_top_height_top' : !isFirstBookingBtnClick}">
                <div class="main_info_area">

                    <h1 class="event_title_div" v-if="$root.checkEventIsExpired(event) == 0 || $root.checkEventIsExpired(event) == 2">
                        {{event.eventTitle}}
                    </h1>
                    <h1 class="event_title_div" v-if="$root.checkEventIsExpired(event) == 1">
                        {{label['event_details_text_enrolment_date_is_over_event_title']}}{{event.eventTitle}}
                    </h1>
                    <!--<div class="event_logo_div">
                    <img :src="logo" align="absmiddle" v-for="(logo,index) in event.eventLogo" />
                </div>-->

                    <div class="info_tag_div">

                        <!--<div class="event_info_tag full mall">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_mall']}}</div>
                                <div class="tag_content_text" v-html="event.mall.mallName"></div>
                            </div>
                        </div>
                    </div>-->

                        <div class="event_info_tag full date">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_date']}}</div>
                                    <div class="tag_content_text" v-html="selectEventDateDisplay"></div>
                                    <div class="tag_content_text" v-html="event.ticketInfo"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag full venue">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_venue']}}</div>
                                    <div class="tag_content_text" v-html="$root.selectEventLocationDisplay(event.location)" v-if="event.location.length > 0"></div>
                                    <div class="tag_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                    <div class="tag_extra" @click="openHowToGetThere()" v-if="event.howToGetThere != ''">{{label['event_common_text_venue_how_to_get_there']}}</div>

                                    <div class="tag_google_map" v-if="event.mettingPointlong != ''">
                                        <div class="tag_google_map_text">{{label['event_details_text_ExternalMeetingPoint']}}</div>
                                        <div class="tag_google_map_btn">
                                            <a :href="$root.writeGoogleMapPath(event.mettingPointlong,event.mettingPointlat)" target="_blank">{{label['event_details_text_GoogleMap']}}</a>
                                        </div>
                                    </div>
                                    <div class="tag_content_text" v-html="event.mettingPointAddress" v-if="event.mettingPointAddress != ''"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag full price">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_price']}}</div>
                                    <div class="tag_content_text" v-html="event.priceInfo"></div>
                                </div>
                            </div>
                        </div>

                        <!--<div class="event_info_tag quota">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_no_quota']}}</div>
                                    <div class="tag_content_text" v-html="event.sessonMaxQuota"></div>
                                </div>
                            </div>
                        </div>-->

                        <div class="event_info_tag language full" v-if="selectEventLanguageDisplay != ''">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_language']}}</div>
                                    <div class="tag_content_text" v-html="selectEventLanguageDisplay"></div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <transition name="slide-up">
                        <div class="event_desc_area" v-if="!isFirstBookingBtnClick">
                            <div class="event_decription_div">
                                <div class="event_desc_div" v-if="event.eventDesc1 != ''" v-html="event.eventDesc1"></div>
                            </div>
                            <div class="event_tnc_div" @click="openEventTNC()">{{label['event_details_text_tnc']}}</div>
                        </div>
                    </transition>

                    <div class="event_logo_div display_responsive isflex">
                        <div class="event_log_inner_div" v-for="(logo,index) in event.eventLogo">
                            <div class="logo_name_div">{{logo.logoName}}</div>
                            <div class="logo_image_div">
                                <img :src="logo.logoImgPath" align="absmiddle" />
                            </div>
                        </div>
                    </div>

                    <transition name="slide-up">
                        <div class="event_decription_div" v-if="!isFirstBookingBtnClick">
                            <div class="event_desc_div" v-if="event.eventDesc2 != ''" v-html="event.eventDesc2"></div>
                        </div>
                    </transition>
                </div> <!-- main_info_area end -->


                <div style="width:100%" v-if="event.quotaPerOrder > 0">
                    <transition name="slide-up">
                        <div class="top_booknow_area" v-if="!isFirstBookingBtnClick">
                            <div style="width:100%" v-if="!event.canEnrolment && !event.isPassEvent">
                                <!--<div class="event_common_highlight_text" v-if="event.beforeEnrolmentDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                                <div class="event_common_highlight_text" v-if="event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                                <div class="event_common_highlight_text" v-if="!event.beforeEnrolmentDate && !event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>-->
                                <div class="booknow_btn inactive" v-if="event.beforeEnrolmentDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                                <div class="booknow_btn inactive" v-if="event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                                <div class="booknow_btn inactive" v-if="!event.beforeEnrolmentDate && !event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                            </div>
                            <div style="width:100%" v-if="!event.canEnrolment && event.isPassEvent">
                                <div class="booknow_btn inactive" v-if="event.beforePostingDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                                <div class="booknow_btn inactive" v-if="event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                                <div class="booknow_btn inactive" v-if="!event.beforePostingDate && !event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                            </div>
                            <div style="width:100%" v-if="event.canEnrolment && !event.isPassEvent">
                                <div class="booknow_btn" :class="{inactive : !EventBookNowBtnEnable()}" @click="FirstBookingBtnClick()">{{EventBookNowBtnLabel1}}</div>
                            </div>
                        </div>
                    </transition> <!-- top_booknow_area end -->
                </div>

                <div class="addthis_div display_desktop" v-if="$root.addThisId != ''">
                    <div class="addthis_inline_share_toolbox"></div>
                </div>

            </div> <!-- event_info_area end -->

            <div class="event_image_desc_area">
                <div class="event_image_area">
                    <div class="date_over_layer" :class="{ layer1: $root.checkEventIsExpired(event) == 1, layer2: $root.checkEventIsExpired(event) == 2, 'en': $root.info.lang == 'en', 'tc': $root.info.lang == 'tc', 'sc': $root.info.lang == 'sc' }" v-if="$root.checkEventIsExpired(event) == 1 || $root.checkEventIsExpired(event) == 2"></div>
                    <img :src="event.eventImages[0]" align="absmiddle" />
                </div>

                <transition name="slide-up">
                    <div class="event_desc_area" v-if="!isFirstBookingBtnClick">
                        <div class="event_decription_div">
                            <div class="event_desc_div" v-if="event.eventDesc1 != ''" v-html="event.eventDesc1"></div>
                        </div>
                        <div class="event_tnc_div" @click="openEventTNC()">{{label['event_details_text_tnc']}}</div>
                    </div>
                </transition>

                <div class="event_logo_div display_desktop isflex">
                    <div class="event_log_inner_div" v-for="(logo,index) in event.eventLogo">
                        <div class="logo_name_div">{{logo.logoName}}</div>
                        <div class="logo_image_div">
                            <img :src="logo.logoImgPath" align="absmiddle" />
                        </div>
                    </div>
                </div>
            </div> <!-- event_image_desc_area end -->

            <transition name="slide-up">
                <div class="event_resp_desc_area" v-if="!isFirstBookingBtnClick">
                    <div class="event_desc_area">
                        <div class="event_decription_div">
                            <div class="event_desc_div" v-if="event.eventDesc1 != ''" v-html="event.eventDesc1"></div>
                        </div>
                        <div class="event_tnc_div" @click="openEventTNC()">{{label['event_details_text_tnc']}}</div>
                    </div>

                    <!--
                    <div style="width:100%" v-if="event.quotaPerOrder > 0">
                        <div style="width:100%" v-if="!event.canEnrolment && !event.isPassEvent">
                            <div class="booknow_btn inactive" v-if="event.beforeEnrolmentDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                            <div class="booknow_btn inactive" v-if="event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                            <div class="booknow_btn inactive" v-if="!event.beforeEnrolmentDate && !event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                        </div>
                        <div style="width:100%" v-if="!event.canEnrolment && event.isPassEvent">
                            <div class="booknow_btn inactive" v-if="event.beforePostingDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                            <div class="booknow_btn inactive" v-if="event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                            <div class="booknow_btn inactive" v-if="!event.beforePostingDate && !event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                        </div>
                        <div style="width:100%" v-if="event.canEnrolment && !event.isPassEvent">
                            <div class="booknow_btn" :class="{inactive : !EventBookNowBtnEnable()}" @click="FirstBookingBtnClick()">{{EventBookNowBtnLabel1}}</div>
                        </div>
                    </div>
                    -->
                    <div class="addthis_div display_responsive" v-if="$root.addThisId != ''">
                        <div class="addthis_inline_share_toolbox"></div>
                    </div>
                </div>
            </transition> <!-- event_resp_desc_area end -->

            <transition name="slide-down">
                <div class="event_details_input_area" id="event_details_input_area" v-if="isFirstBookingBtnClick">

                    <div class="event_calendar_qty_area">

                        <div class="event_calendar_area" :class="{'isSticky pane_top_height_top' : isFirstBookingBtnClick}">

                            <div class="event_calendar_title">{{label['event_details_text_select_a_date']}}</div>

                            <div class="event_calendar_select_area" id="event_calendar_select_area"></div>

                            <div class="event_time_select_area">
                                <div class="event_time_title">{{label['event_details_text_time']}}</div>

                                <div class="event_time_select_div">
                                    <div class="event_time_display_div" @click="sessionListSelectOpen()" :class="{isOpen : sessionListOpen}">
                                        <div class="event_time_display_text" v-html="sessionSelectTimeDisplay()"></div>
                                        <div class="event_time_display_select_icon" v-if="selectEventData.dateSessionList.length > 1"></div>
                                    </div>
                                    <transition name="sliderDivFast">
                                        <div class="event_time_option_div" v-if="sessionListOpen">

                                            <div class="event_time_option"
                                                 v-for="(session,index) in selectEventData.dateSessionList"
                                                 :key="'session'+index"
                                                 @click="sessionSelect(session)">
                                                {{$root.sessionTimeFormat(session.eventStartTime) + " - " + $root.sessionTimeFormat(session.eventEndTime)}} <span class="session_remark">{{$root.selectSessionSessionRemarkDisplay(session, true)}}</span>
                                            </div>

                                        </div>
                                    </transition>
                                </div>
                            </div>

                        </div>

                        <div class="event_qty_area" :key="priceTagIsUpdate">
                            <div class="event_decription_div">
                                <div class="event_desc_div" v-if="event.eventDesc3 != ''" v-html="event.eventDesc3"></div>
                            </div>

                            <div class="event_qty_select_area">
                                <div class="event_qty_title">{{label['event_common_text_quantity']}}</div>

                                <div class="event_qty_select_div">

                                    <div class="event_qty_select_tag_row"
                                         v-for="(priceTag,index) in selectEventData.selectPriceTag.filter((o) => o.singlePrice >= 0)"
                                         :key="'priceTag'+index">
                                        <div class="tag_name">
                                            {{$root.writePriceTagName(priceTag)}}
                                        </div>
                                        <div class="tag_qty_select">
                                            <div class="tag_icon min" @click="eventPriceTagQtyAdd(priceTag,'min')"></div>
                                            <div class="tag_qty">{{priceTag.selectQty}}</div>
                                            <div class="tag_icon plus" @click="eventPriceTagQtyAdd(priceTag,'add')"></div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div class="event_amount_area">

                                <div class="amount_list_div">

                                    <div class="amount_list_row">
                                        <div class="amount_name">{{label['event_common_text_original_price']}}</div>
                                        <div class="amount_value"><money :price="selectEventData.totalPrice" /></div>
                                    </div>

                                    <div class="amount_list_row"
                                         v-for="(discount,index) in selectEventData.selectPriceTag.filter((o) => (o.tagDiscount != null && o.totalDiscount > 0))"
                                         :key="'discount'+index">
                                        <div class="amount_name">{{$root.writePriceTagName(discount)}} {{label['event_common_text_discounted']}} {{discount.tagDiscount.discount}}% {{label['event_common_text_off']}}</div>
                                        <div class="amount_value">-<money :price="discount.totalDiscount" /></div>
                                    </div>

                                    <div class="amount_list_row isBold">
                                        <div class="amount_name">{{label['event_common_text_total']}}</div>
                                        <div class="amount_value"><money :price="selectEventData.finalPrice" /></div>
                                    </div>

                                </div>

                            </div>

                            <div class="event_confirmation_message_area_main">
                                <div class="event_confirmation_message_area" :class="{selected : isConfirmationMessage}"  @click="ConfirmationMessageClick(1)" v-if="event.confirmation_message != ''">
                                    <div class="checkbox_div"></div>
                                    <div class="message_div">{{event.confirmation_message}}</div>
                                </div>
                                <div class="event_confirmation_message_area" :class="{selected : isConfirmationMessage_2}"  @click="ConfirmationMessageClick(2)" v-if="event.confirmation_message_2 != ''">
                                    <div class="checkbox_div"></div>
                                    <div class="message_div">{{event.confirmation_message_2}}</div>
                                </div>
                                <div class="event_confirmation_message_area" :class="{selected : isConfirmationMessage_3}"  @click="ConfirmationMessageClick(3)" v-if="event.confirmation_message_3 != ''">
                                    <div class="checkbox_div"></div>
                                    <div class="message_div">{{event.confirmation_message_3}}</div>
                                </div>
                            </div>
                        </div>

                    </div><!-- event_calendar_qty_area end -->

                    <div class="bottom_booknow_area">
                        <div class="booknow_btn" v-if="event.canEnrolment" :class="{inactive : !checkCanBookNow()}" @click="eventBookNow()">{{EventBookNowBtnLabel2}}</div>
                    </div>
                </div>
            </transition> <!-- event_details_input_area end -->

        </div>
        <!-- eventDetails_area_content end -->


        <div class="event_main_booknow_div" v-if="event.quotaPerOrder > 0 && !isFirstBookingBtnClick">
            <div style="width:100%" v-if="!event.canEnrolment && !event.isPassEvent">
                <!--<div class="event_common_highlight_text" v-if="event.beforeEnrolmentDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                <div class="event_common_highlight_text" v-if="event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                <div class="event_common_highlight_text" v-if="!event.beforeEnrolmentDate && !event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>-->
                <div class="booknow_btn inactive" v-if="event.beforeEnrolmentDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                <div class="booknow_btn inactive" v-if="event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                <div class="booknow_btn inactive" v-if="!event.beforeEnrolmentDate && !event.afterEnrolmentDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
            </div>
            <div style="width:100%" v-if="!event.canEnrolment && event.isPassEvent">
                <div class="booknow_btn inactive" v-if="event.beforePostingDate">{{label['event_details_text_enrolment_date_not_start']}}</div>
                <div class="booknow_btn inactive" v-if="event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
                <div class="booknow_btn inactive" v-if="!event.beforePostingDate && !event.afterPostingDate">{{label['event_details_text_enrolment_date_is_over']}}</div>
            </div>
            <div style="width:100%" v-if="event.canEnrolment && !event.isPassEvent">
                <div class="booknow_btn" :class="{inactive : !EventBookNowBtnEnable()}" @click="FirstBookingBtnClick()">{{EventBookNowBtnLabel1}}</div>
            </div>
        </div>


        <transition name="slide-down">
            <div class="you_many_like_area" v-if="(!isPreviewPage && !isFirstBookingBtnClick) && YouMayAlsoLikeList.length > 0">
                <div class="you_many_like_list_area">

                    <div class="you_many_like_title">
                        {{label['event_details_text_you_may_also_like']}}
                    </div>

                    <div class="event_list_tag"
                         v-for="(event,index) in YouMayAlsoLikeList"
                         :key="'event'+index"
                         @click="$root.goEventDetailsPage(event)">
                        <div class="event_list_area">
                            <div class="image_outer_div">
                                <div class="image_inner_div">
                                    <div class="date_over_layer" :class="{ layer1: $root.checkEventIsExpired(event) == 1, layer2: $root.checkEventIsExpired(event) == 2, 'en': $root.info.lang == 'en', 'tc': $root.info.lang == 'tc', 'sc': $root.info.lang == 'sc' }" v-if="$root.checkEventIsExpired(event) == 1 || $root.checkEventIsExpired(event) == 2"></div>
                                    <img :src="event.eventImages[0]" align="absmiddle" />
                                </div>
                            </div>
                            <div class="data_area">
                                <div class="date_div" v-html="EventListDateDisplay(event)"></div>
                                <div class="title_div" v-if="$root.checkEventIsExpired(event) == 0 || $root.checkEventIsExpired(event) == 2">
                                    {{event.eventTitle}}
                                </div>
                                <div class="title_div" v-if="$root.checkEventIsExpired(event) == 1">
                                   {{label['event_details_text_enrolment_date_is_over_event_title']}}{{event.eventTitle}}
                                </div>
                                <div class="location_div" v-if="event.location.length > 0">
                                    <div class="location_icon"></div>
                                    <div class="location_text" v-html="$root.selectEventLocationDisplay(event.location)"></div>
                                </div>
                            </div>
                        </div>
                    </div> <!-- event_list_tag end -->

                </div>
            </div>
        </transition>
        <!-- you_many_like_area end -->

        <!-- HowToGetThere start -->
        <transition name="slide-up">
            <div class="how_to_get_there_div" v-if="isOpenHowToGetThere" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="how_to_get_there_div_background" @click="closeHowToGetThere()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="how_to_get_there_div_layer">
                    <div class="how_to_get_there_inner_div">
                        <div class="how_to_get_there_top_div">
                            <div class="close_icon" @click="closeHowToGetThere()"></div>
                        </div>
                        <div class="how_to_get_there_middle_div">
                            <div class="header_div">
                                {{label['event_common_text_venue_how_to_get_there_layer_title']}}
                            </div>
                            <div class="body_div">

                                <div class="image_div">
                                    <img :src="event.howToGetThere" align="absmiddle" />
                                </div>
                                <div class="location_div">
                                    <div class="location_icon"></div>
                                    <div class="location_content">
                                        <div class="location_title">
                                            {{label['event_common_text_venue']}}
                                        </div>
                                        <div class="location_content_text" v-html="event.location.locationName" v-if="event.location.locationName != ''"></div>
                                        <div class="location_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <!-- HowToGetThere end

        <!-- checkout tnc start -->
        <transition name="slide-up">
            <div class="tnc_popup_div" v-if="isOpenEventTNC" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="tnc_popup_div_background" @click="closeEventTNC()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="tnc_popup_div_layer">
                    <div class="tnc_popup_inner_div">
                        <div class="tnc_popup_top_div">
                            <div class="close_icon" @click="closeEventTNC()"></div>
                        </div>
                        <div class="tnc_popup_middle_div">
                            <div class="header_div">
                                {{label['checkout_text_tnc_header']}}
                            </div>
                            <div class="body_div">
                                <div class="body_content" v-html="eventTNCContent"></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <!-- checkout tnc end -->




    </div>
</template>
 
<script>
    export default {
        data() {
            return {
                isPreviewPage: this.$root.info.currentPathName == "/eventpreview" ? true : false,
                isOpenHowToGetThere: false,
                isOpenEventTNC: false,
                eventTNCContent: "",
                EventBookNowBtnLabel1: "",
                EventBookNowBtnLabel2: "",

                //eventId: -1,
                eventCode: "",
                event: null,
                eventIsUpdate: 0,
                sessionListOpen:false,
                priceTagIsUpdate: 0,

                allSessionList: [],

                isFirstBookingBtnClick: false,
                selectEventData: {
                    selectEvent: null,
                    selectDate: "",
                    dateSessionList: [],
                    selectSession: null,
                    selectSessionGroup: [],
                    selectPriceTag: [],
                    totalSelectQty: 0,
                    totalSelectQuota: 0,
                    totalPrice: 0,
                    totalDiscount: 0,
                    finalPrice: 0,
                    submitWaitingList:false,
                },

                YouMayAlsoLikeList: [],

                isConfirmationMessage: false,
                isConfirmationMessage_2: false,
                isConfirmationMessage_3: false,

            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            selectEventLanguageDisplay() {
                var app = this;
                var languageDisplay = "";
                $.each(this.event.language, function (key, value) {
                    if (app.info.lang == "tc" || app.info.lang == "sc") {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : "、") + value.languageName;
                    }
                    else {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : ", ") + value.languageName;
                    }
                });
                /*
                if (languageDisplay == "")
                    languageDisplay = this.label['event_common_text_language_NotSpecified'];
                */
                return languageDisplay;
            },
            selectEventDateDisplay() {
                return this.$root.writeDisplayDateFormat(this.event.eventStartDate) + (this.event.eventStartDate != this.event.eventEndDate ? " - " + this.$root.writeDisplayDateFormat(this.event.eventEndDate) : "")
            }
        },
        components: {},
        created() {        
            var app = this;
            this.info.loading = true;
            this.$root.getCurrentPathName();

            if (!app.isPreviewPage) {
                if (app.$route.params.eventId) {
                    //app.eventId = parseInt(app.$route.params.eventId, 10);
                    app.eventCode = app.$route.params.eventId;

                    //if (app.eventId) {
                    if (app.eventCode != "") {
                        app.initEvent();
                    }
                    else {
                        this.$router.replace(`/` + this.info.lang + `/`);
                    }

                } else {
                    this.$router.replace(`/` + this.info.lang + `/`);
                }

                /*if (this.$root.addThisId != "") {
                    addThisLayerRefresh();
                }*/
            }
            else {
                this.initEventPreviewData();
            }
            
        },
        destroyed() {
            //this.eventId = -1;
            this.eventCode = "";
            this.event = null;
        },
        watch: {
            '$root.info.lang': function (lang) {
                if (!this.isPreviewPage) {
                    if (this.isFirstBookingBtnClick) {
                        //this.selectEventData.selectDate = "";
                        //this.selectEventData.selectSession = null;
                        this.info.loading = true;
                        this.initEvent(true);
                    }
                    else {
                        this.info.loading = true;
                        this.initEvent(false);
                        this.EventBookNowBtnEnable();
                    }
                }
            },
            '$route.params.eventId': function (eventId) {
                if (!this.isPreviewPage) {
                    this.eventCode = eventId;
                    this.eventIsUpdate++;
                    this.initEvent();
                    //addThisLayerRefresh();
                }
            },
            '$root.info.member': function (member) {
                if (member == null) {
                    this.$root.ReloadCurrentPage();
                    //this.$router.push(`/` + this.info.lang + `/`);
                }
            }
        },
        mounted() {            
        },
        methods: {
            EventListDateDisplay(event) {
                return this.$root.writeDisplayDateFormat(event.eventStartDate) + (event.eventStartDate != event.eventEndDate ? " - " + this.$root.writeDisplayDateFormat(event.eventEndDate) : "")
            },

            isEventDetailsBackDisplay() {
                return (!this.isPreviewPage && this.info.order_temp_info.order_device == 'web');
            },
            eventDetailsBack() {
                if (this.isEventDetailsBackDisplay) {
                    this.$router.push(`/` + this.info.lang + `/`);
                }
            },

            initEventPreviewData() {
                var app = this;
                var eventPrevieDataName = app.$root.getParameterByName("name");
                console.log("eventPrevieDataName", eventPrevieDataName)

                $.ajax({
                    type: "GET",
                    url: "/eventPrevieData/" + moment().format("YYYYMMDD") + "/" + eventPrevieDataName + ".json",
                    dataType: "json",
                    success: (data) => {
                        console.log("eventPrevieData", data);
                        app.$root.info.loading = false;

                        try {
                            /*
                            if (data.enrollType == "y") {
                                data.eventStartDate = data.enrolmentStartDate.split(" ")[0];
                                data.eventEndDate = data.enrolmentEndDate.split(" ")[0];
                            }
                            else {
                                var sessionDateAsc = multiSort(eventDetails.eventSession.slice(), { "eventDate": "asc" });
                                var sessionDateDesc = multiSort(eventDetails.eventSession.slice(), { "eventDate": "desc" });
                                data.eventStartDate = sessionDateAsc[0].eventDate;
                                data.eventEndDate = sessionDateDesc[0].eventDate;
                            }
                            */
                            data.eventStartDate = data.eventStartDate.split(" ")[0];
                            data.eventEndDate = data.eventEndDate.split(" ")[0];
                            app.fillEventData(data);
                        }
                        catch (e) {
                            alert(e.message);
                        }
                    }
                }).catch(function (e) {
                    alert(e.status + " - " + e.statusText);
                });
            },

            initEventPageData() {
                this.event = null;
                this.eventIsUpdate++;
                this.sessionListOpen = false;

                this.allSessionList = [];

                this.isFirstBookingBtnClick = false;
                this.selectEventData = {
                    selectEvent: null,
                    selectDate: "",
                    dateSessionList: [],
                    selectSession: null,
                    selectSessionGroup: [],
                    selectPriceTag: [],
                    totalSelectQty: 0,
                    totalSelectQuota: 0,
                    totalPrice: 0,
                    totalDiscount: 0,
                    finalPrice: 0,
                    submitWaitingList: false,
                };
            },
            initEvent(loadDatepicker) {
                var app = this;                
                var filter_json = {
                    //"eventId": app.eventId
                    "eventCode": app.eventCode
                };

                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: (app.info.member == null ? "" : app.info.member.memberToken) },
                    url: app.info.wsUrl + "/Event/GetEventDetails",
                    async: true,
                    contentType: "application/json",
                    data: JSON.stringify(filter_json),
                    dataType: "json",
                    success: (data) => {
                        console.log("GetEventDetails", data);
                        app.$root.info.loading = false;

                        if (data.status == 0) {
                            app.$root.tempEventDetailsData = {
                                eventId: data.eventDetails.eventId,
                                eventCode: data.eventDetails.eventCode,
                                eventEncode: data.eventDetails.eventEncode
                            };
                            app.fillEventData(data.eventDetails);

                            if (!app.isPreviewPage) {
                                app.getYouMayAlsoLikeList();
                            }

                            if (loadDatepicker) {
                                app.initDatePicker();
                                if (app.selectEventData.selectDate != "") {
                                    var tempDate = app.selectEventData.selectDate;
                                    app.selectEventData.selectDate = "";
                                    app.eventSessionClick(tempDate, true);
                                }                                
                            }

                            if (app.$root.addThisId != "") {
                                addThisLayerRefresh();
                            }

                            this.initOpenTnc();
                            this.initOpenEventClick();
							
							this.eventDetailsPageReplaceState();
                        }
                        else {
                            app.$root.alert(app.label['event_details_text_event_not_found']);
                            app.$router.replace(`/` + app.info.lang + `/`);
                        }
                    },
                });
            },
            fillEventData(eventDetails) {
                var app = this;
                app.event = eventDetails;

                //var sessionDateAsc = multiSort(eventDetails.eventSession.slice(), { "eventDate": "asc" });
                //var sessionDateDesc = multiSort(eventDetails.eventSession.slice(), { "eventDate": "desc" });
                //var sessionQuotaAsc = multiSort(eventDetails.eventSession.slice(), { "eventMinQuota": "asc" });
                //var sessionQuotaDesc = multiSort(eventDetails.eventSession.slice(), { "eventMaxQuota": "desc" });

                //app.event.sessonStartDate = sessionDateAsc[0].eventDate;
                //app.event.sessonEndDate = sessionDateDesc[0].eventDate;
                //app.event.sessonMinQuota = sessionQuotaAsc[0].eventMinQuota;
                //app.event.sessonMaxQuota = sessionQuotaDesc[0].eventMaxQuota;
                
                app.checkEventSessionList();
                app.selectEventData.selectEvent = JSON.parse(JSON.stringify(app.event));
                app.selectEventData.selectPriceTag = JSON.parse(JSON.stringify(app.event.priceTagClass));                
                app.resetSelectPriceTagData();

                // check confirmation_message start
                if (app.selectEventData.selectEvent.confirmation_message == '') {
                    app.isConfirmationMessage = true;
                }
                if (app.selectEventData.selectEvent.confirmation_message_2 == '') {
                    app.isConfirmationMessage_2 = true;
                }
                if (app.selectEventData.selectEvent.confirmation_message_3 == '') {
                    app.isConfirmationMessage_3 = true;
                }
                // check confirmation_message end

                app.$root.setPageTitle(app.selectEventData.selectEvent.eventTitle);
				//$('meta[property="description"]').attr('content', app.selectEventData.selectEvent.eventDescNoHTML);
				//$('meta[property="keywords"]').attr($("head>title").text());
                $('meta[property="og:title"]').attr('content', app.selectEventData.selectEvent.eventTitle);
				//$('meta[property="og:description"]').attr('content', app.selectEventData.selectEvent.eventDescNoHTML);
                $('meta[property="og:url"]').attr('content', app.selectEventData.selectEvent.eventShareURL);
                $('meta[property="og:image"]').attr('content', app.selectEventData.selectEvent.eventImages[0]);				
            },
			eventDetailsPageReplaceState() {
				window.history.replaceState(null, null, (this.selectEventData.selectEvent.eventBaseURL));
			},
            checkEventSessionList() {
                var app = this;
                app.allEventSessionList = [];

                if (app.event.canEnrolment) {
                    if (this.event.allSessionFullComplete) {
                        if (this.event.isWaitingList) {
                            app.fillEventSessionList(false);
                        }
                    }
                    else {
                        if (this.event.allSessionFull) {
                        }
                        else {
                            app.fillEventSessionList(true);
                        }
                    }
                    /*
                    if (app.allEventSessionList.length <= 0) {
                        app.event.canEnrolment = false;
                    }
                    */
                }
                console.log("app.allEventSessionList", app.allEventSessionList);
            },
            fillEventSessionList(checkQuota) {
                var app = this;
                $.each($(app.event.eventSession), function (key, s) {
                    // check today start
                    if (moment(moment().format("YYYY/MM/DD")) <= moment(s["eventDate"])) {

                        // check quota start
                        if (checkQuota) {
                            if (s["eventJoin"] < s["eventMaxQuota"]) {
                                if (app.checkEventSessionDateTime(s, app.event.lateJoinEvent, app.event.orderCutOffDaysBefore)) {
                                    app.allEventSessionList.push(s);
                                }
                            }
                        }
                        else {
                            if (app.checkEventSessionDateTime(s, app.event.lateJoinEvent, app.event.orderCutOffDaysBefore)) {
                                app.allEventSessionList.push(s);
                            }
                        }
                        // check quota end

                    }
                    // check today end
                });
            },
            checkEventSessionDateTime(s, lateJoinEvent, orderCutOffDaysBefore) {
                // add orderCutOffDaysBefore on 20241114
                var checkDate = moment(s["eventDate"]);
                if (orderCutOffDaysBefore != undefined && orderCutOffDaysBefore > 0) {
                    checkDate = checkDate.add((-1 * this.event.orderCutOffDaysBefore), 'days');
                }

                // added lateJoinEvent on 20240108
                if (moment(s["eventDate"]).format("YYYY/MM/DD") == moment().format("YYYY/MM/DD")) {
                    if (lateJoinEvent) {
                        if (moment(checkDate.format("YYYY/MM/DD") + " " + s["eventEndTime"] + ":00") <= moment()) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        if (moment(checkDate.format("YYYY/MM/DD") + " " + s["eventStartTime"] + ":00") <= moment()) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                }
                else {
                    if (checkDate < moment(moment().format("YYYY/MM/DD"))) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            },
            resetSelectPriceTagData() {
                var app = this;
                $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                    tag.selectQty = 0;
                    tag.totalHeadCount = 0;
                    tag.totalPrice = 0;
                    tag.singlePrice = -1;
                    tag.tagDiscount = null;
                    tag.totalDiscount = 0;
                    tag.discountList = $(app.event.priceTagDiscount).filter((i, o) => o["priceTagId"] == tag["priceTagId"]).slice();
                });
            },
            eventPriceTagQtyAdd(priceTag, type) {
                var app = this;
                if (app.selectEventData.selectSession != null) {
                    var caculatePrice = true;

                    if (type == "add") {
                        // check quota per order
                        /*
                        // count as headcount
                        var current_count = 0;
                        var tag_headcount = 1;
                        $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                            current_count = current_count + (tag.selectQty * tag.headCount);
                            if (tag.priceTagId == priceTag.priceTagId) {
                                tag_headcount = tag.headCount;
                            }
                        });
                        var add_count = current_count + tag_headcount; 
                        */
                        var current_count = 0;
                        $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                            current_count = current_count + tag.selectQty;
                        });
                        var add_count = current_count + 1; // count as qty

                        if (add_count <= app.event.quotaPerOrder) {
                            priceTag.selectQty++;
                        }
                        else {
                            caculatePrice = false;
                            app.$root.alert(app.label['event_details_text_over_quota_per_order']);
                        }
                    }
                    else {
                        priceTag.selectQty--;
                        if (priceTag.selectQty < 0)
                            priceTag.selectQty = 0;
                    }

                    if (caculatePrice) {
                        app.caculateEventPirce();
                        app.priceTagIsUpdate++;
                    }
                } else {
                    app.$root.alert(app.label['event_details_text_please_select_a_session']);   
                }

            },
            caculateEventPirce() {
                var app = this;

                var discountList = [];
                app.selectEventData.totalSelectQty = 0;
                app.selectEventData.totalSelectQuota = 0;
                app.selectEventData.totalPrice = 0;
                app.selectEventData.totalDiscount = 0;
                app.selectEventData.finalPrice = 0;
                $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                    tag.totalHeadCount = tag.selectQty * tag.headCount;
                    tag.totalPrice = tag.selectQty * tag.singlePrice;

                    app.selectEventData.totalSelectQty = app.selectEventData.totalSelectQty + tag.selectQty;
                    app.selectEventData.totalSelectQuota = app.selectEventData.totalSelectQuota + tag.totalHeadCount;
                    app.selectEventData.totalPrice = app.selectEventData.totalPrice + tag.totalPrice;

                    // check discount
                    discountList = $(tag.discountList).filter((i, o) => o["joinCount"] <= tag.selectQty);
                    if (discountList.length > 0) {
                        tag.tagDiscount = discountList[discountList.length - 1];
                        tag.tagDiscount.discountAmount = MathPriceFloor100(tag.totalPrice * (tag.tagDiscount["discount"] / 100));
                        tag.totalDiscount = tag.tagDiscount.discountAmount;
                    }
                    else {
                        tag.tagDiscount = null;
                        tag.totalDiscount = 0;
                    }

                    app.selectEventData.totalDiscount = app.selectEventData.totalDiscount + tag.totalDiscount;
                    app.selectEventData.finalPrice = app.selectEventData.finalPrice + (tag.totalPrice - tag.totalDiscount);
                });

            },

            eventSessionClick(selectDate, reSelectSession) {
                if (reSelectSession == undefined || reSelectSession == null) {
                    reSelectSession = false;
                }
                var app = this;

                if (app.selectEventData.selectDate != selectDate) {
                    app.selectEventData.selectDate = selectDate;
                    var tempSession = (app.selectEventData.selectSession != null ? JSON.parse(JSON.stringify(app.selectEventData.selectSession)) : null);
                    app.selectEventData.selectSession = null;

                    // reset price tag data
                    //app.resetSelectPriceTagData();

                    // get session list
                    //app.selectEventData.dateSessionList = $(app.allEventSessionList).filter((i, o) => o["eventDate"] == selectDate).slice();
                    //app.sessionSelect(app.selectEventData.dateSessionList[0]);
                    app.selectEventData.dateSessionList = [];
                    $.each($(app.allEventSessionList).filter((i, o) => o["eventDate"] == selectDate), function (key, s) {
                        if (app.checkEventSessionDateTime(s, app.event.lateJoinEvent, app.event.orderCutOffDaysBefore)) {
                            app.selectEventData.dateSessionList.push(JSON.parse(JSON.stringify(s)));
                        }
                    });

                    if (app.selectEventData.dateSessionList.length > 0) {
                        if (reSelectSession && tempSession != null) {
                            app.sessionSelect(tempSession);
                        }
                        else {
                            app.sessionSelect(app.selectEventData.dateSessionList[0]);
                        }
                    }
                    else {
                        app.$root.alert(app.label['checkout_error_text_event_not_found']);
                        app.$root.removeOrderData();
                        app.selectEventData.selectDate = "";
                        app.selectEventData.selectSession = null;
                        app.initEvent(true);
                    }

                    // recaculate price
                    //app.caculateEventPirce();
                }
            },
            sessionSelect(session) {
                var app = this;
                app.selectEventData.selectSession = session;

                // reset price tag data
                app.resetSelectPriceTagData();

                // get session price
                $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                    tag.singlePrice = tag["priceClass_" + session.eventPriceClass.toLowerCase()];
                });

                // recaculate price
                app.caculateEventPirce();

                app.sessionListOpen = false;
            },            
            sessionSelectTimeDisplay() {
                if (this.selectEventData.selectSession == null) {
                    return "--:--";
                }
                else {
                    var app = this;
                    return app.$root.sessionTimeFormat(app.selectEventData.selectSession.eventStartTime) + " - " + app.$root.sessionTimeFormat(app.selectEventData.selectSession.eventEndTime) + '&#160;<span class="session_remark">' + app.$root.selectSessionSessionRemarkDisplay(app.selectEventData.selectSession, true) + '</span>';
                }
            },
            sessionListSelectOpen() {
                if (this.selectEventData.dateSessionList.length > 1) {
                    if (this.sessionListOpen) {
                        this.sessionListOpen = false;
                    } else {
                        this.sessionListOpen = true;
                    }
                }
            },

            FirstBookingBtnClick(isScroll) {
                if (!this.isPreviewPage) {

                    if (this.EventBookNowBtnEnable()) {
                        if (this.info.member != null) {
                            this.FirstBookingBtnRun(isScroll);
                        }
                        else {
                            this.$root.LoginBtnClick();
                        }
                    }

                } else {
                    this.FirstBookingBtnRun();
                }
            },
            FirstBookingBtnRun(isScroll) {
                if (isScroll == undefined || isScroll == null)
                    isScroll = true;

                var app = this;
                var gathis = this;
                gathis.$root.NFGA_FillParam("NFGA_EventPage_Next", "'" + app.event.eventTitleEN + "'", "'" + app.event.mall.NFMallID + "'", "'" + app.event.mall.mallName + "'");
                
                app.isFirstBookingBtnClick = true;

                // scroll to event list top
                setTimeout(function () {
                    app.initDatePicker();

                    app.$root.GetHeaderHeight();
                    var event_details_input_area = app.$el.querySelector("#event_details_input_area");
                    var scroll_y = ($(event_details_input_area).offset().top - app.$root.header_div_info.height);
                    if (isScroll)
                        app.$root.scrollToXYAnimate({ "x": window.top.scrollX, "y": (scroll_y < 0 ? 0 : scroll_y) });
                    else
                        app.$root.scrollToXY({ "x": window.top.scrollX, "y": (scroll_y < 0 ? 0 : scroll_y) });
                }, 500);
            },

            checkCanBookNow(isAlert) {
                if (isAlert == undefined || isAlert == null)
                    isAlert = false;
                var re = false;

                if (this.event.allSessionFullComplete) {
                    if (this.event.isWaitingList) {
                        if (this.selectEventData.selectSession != null) {
                            if (this.selectEventData.totalSelectQty > 0) {

                                if (this.event.minPerOrder <= this.selectEventData.totalSelectQty) {

                                    if (this.isConfirmationMessage && this.isConfirmationMessage_2 && this.isConfirmationMessage_3) {
                                        re = true;
                                        this.selectEventData.submitWaitingList = true;
                                    }
                                    else {
                                        if (isAlert)
                                            this.$root.alert('event_details_text_checking_please_confirm_special_condition');
                                        re = false;
                                    }

                                }
                                else {
                                    if (isAlert)
                                        this.$root.alert(this.label['event_details_text_checking_min_per_order'].replace(/\[\#min_per_order\#\]/g, this.event.minPerOrder));
                                }
                            
                            }
                            else {
                                if (isAlert)
                                    this.$root.alert('event_details_text_checking_please_select_qty');
                                re = false;
                            }
                        }
                        else {
                            if (isAlert)
                                this.$root.alert('event_details_text_checking_please_select_date_and_session');
                            re = false;
                        }
                    }
                    else {
                        re = false;
                    }
                }
                else {
                    if (this.event.allSessionFull) {
                        re = false;
                    }
                    else {
                        if (this.selectEventData.selectSession != null) {
                            if (this.selectEventData.totalSelectQty > 0) {

                                if (this.event.minPerOrder <= this.selectEventData.totalSelectQty) {

                                    if (this.isConfirmationMessage && this.isConfirmationMessage_2 && this.isConfirmationMessage_3) {
                                        re = true;
                                    }
                                    else {
                                        if (isAlert)
                                            this.$root.alert('event_details_text_checking_please_confirm_special_condition');
                                        re = false;
                                    }

                                }
                                else {
                                    if (isAlert)
                                        this.$root.alert(this.label['event_details_text_checking_min_per_order'].replace(/\[\#min_per_order\#\]/g, this.event.minPerOrder));
                                }

                            }
                            else {
                                if (isAlert)
                                    this.$root.alert('event_details_text_checking_please_select_qty');
                                re = false;
                            }
                        }
                        else {
                            if (isAlert)
                                this.$root.alert('event_details_text_checking_please_select_date_and_session');
                            re = false;
                        }
                    }
                }

                return re;
            },
            eventBookNow() {
                var app = this;
                if (!app.isPreviewPage) {
                    if (app.checkCanBookNow(true)) {
                        var priceTag = [];
                        $.each(app.selectEventData.selectPriceTag, function (key, tag) {
                            if (tag.selectQty > 0) {
                                priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.selectQty });
                            }
                        });
                        app.$root.CheckEventOrder(app.selectEventData.selectEvent.eventId, app.selectEventData.selectSession.sessionId, priceTag, [], "", "", app.info.order_temp_info.order_device, app.selectEventData.submitWaitingList, false, "", app.eventBookNowCb);
                    }
                }
            },
            eventBookNowCb(data) {
                console.log("data",data);
                var app = this;

                if (data.status == 0) {
                    var gathis = this;
                    gathis.$root.NFGA_FillParam("NFGA_Add_to_Cart", "'" + app.event.eventTitleEN + "'", "'" + app.event.mall.NFMallID + "'", "'" + app.event.mall.mallName + "'");

                    app.$root.setOrderData(data.orderCore, app.selectEventData.submitWaitingList);
                    app.$router.push(`/` + this.info.lang + `/checkout`);
                } else {

                    if (data.status == 1) {
                        app.$root.alert(app.label['checkout_error_text_event_not_found']);
                        app.$router.replace(`/` + app.info.lang + "/");
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 2) {
                        app.$root.alert(app.label['checkout_error_text_quota_is_over']);
                        app.$root.removeOrderData();

                        app.initEventPageData();
                        app.initEvent();
                    }
                    else if (data.status == 7) {
                        app.$root.alert(app.label['checkout_error_text_limitquota_is_over']);
                        app.$root.removeOrderData();

                        app.initEventPageData();
                        app.initEvent();
                    }
                    else if (data.status == 6) {
                        app.$root.alert(app.label['checkout_error_text_no_permission_join_event']);
                        app.$root.removeOrderData();

                        app.initEventPageData();
                        app.initEvent();
                    }
                    else {

                        if (data.status == 98) {
                            app.$root.removeInfoMemberData();
                            app.$root.ReloadCurrentPage();
                        } else {
                            app.$root.alert(data.detail);
                        }
                    }

                }
            },

            openHowToGetThere() {
                this.isOpenHowToGetThere = true;
                this.$root.setBodyOverflow(true);
            },
            closeHowToGetThere() {
                this.isOpenHowToGetThere = false;
                this.$root.setBodyOverflow(false);
            },
            openEventTNC() {
                this.isOpenEventTNC = true;
                this.$root.setBodyOverflow(true);
                this.eventTNCContent = this.event.eventTNC;
            },
            closeEventTNC() {
                this.isOpenEventTNC = false;
                this.$root.setBodyOverflow(false);
                this.eventTNCContent = "";
            },
            /*
            initDatePicker() {
                var app = this;
                

                var calendar_obj = $("#event_calendar_select_area");
                if (calendar_obj.length > 0) {
                    function addCustomInformation() {
                        $(".ui-datepicker-calendar td").filter(function () {
                            var date = $(this).text();
                            return /\d/.test(date);
                        }).find("a, span").html(function (i, html) {
                            return ('<div class="mydate">' + html + '</div>');
                        });
                    }

                    calendar_obj.datepicker("destroy");
                    calendar_obj.datepicker({
                        changeMonth: false,
                        changeYear: false,
                        //minDate: new Date(),
                        //maxDate: new Date(),
                        onChangeMonthYear: function () {
                            setTimeout(addCustomInformation, 10);
                        },
                        beforeShowDay: function (date) {
                            var highlight = (moment(date).format(app.$root.info.api_date_format) == "20220501");
                            if (highlight) {
                                return [true, "myevent event_date", ""]; // [active, add class, attr title]
                            } else {
                                return [true, "myevent", ""];
                            }
                        },
                        onSelect: function (dateText, inst) {
                            console.log(inst);
                            var selectDate = moment(inst.currentYear + "/" + (inst.currentMonth + 1) + "/" + $(inst.currentDay).text());

                            app.$root.alert(selectDate);   
                            setTimeout(addCustomInformation, 10);
                        }
                    });
                    setTimeout(addCustomInformation, 10);
                }
                else {
                    setTimeout(app.initDatePicker, 100);
                }
            },
            */
            initDatePicker() {
                var app = this;

                var firstSession = null;
                var lastSession = null;
                if (app.allEventSessionList.length > 0) {
                    firstSession = moment(app.allEventSessionList[0]["eventDate"]);
                    lastSession = moment(app.allEventSessionList[app.allEventSessionList.length - 1]["eventDate"]);
                    //app.eventSessionClick(firstSession.format(app.$root.info.api_date_format)); // hide for not selecting the first session when init the calendar
                }
                var calendar_obj = $("#event_calendar_select_area");
                if (calendar_obj.length > 0) {
                    calendar_obj.datepicker("destroy");                    
                    calendar_obj.datepicker({
                        monthNames: app.$root.datePicketLangSetup[app.$root.info.lang].monthNames,
                        dayNamesMin: app.$root.datePicketLangSetup[app.$root.info.lang].dayNamesMin,
                        showMonthAfterYear: app.$root.datePicketLangSetup[app.$root.info.lang].showMonthAfterYear,
                        yearSuffix: app.$root.datePicketLangSetup[app.$root.info.lang].yearSuffix,
                        dateFormat: "yy/mm/dd",
                        changeMonth: false,
                        changeYear: false,
                        //minDate: new Date(moment(app.event.eventStartDate)),
                        //maxDate: new Date(moment(app.event.eventEndDate)),
                        minDate: new Date(moment(firstSession)),
                        maxDate: new Date(moment(lastSession)),
                        beforeShowDay: function (date) {
                            var showDate = moment(date).format(app.$root.info.api_date_format);
                            var date_active = false;
                            var date_class = "";

                           // check select date
                            if (app.selectEventData.selectDate == showDate) {
                                date_active = true;
                                date_class = date_class + "event_select ";
                            }

                            // check is event date or not
                            if (checkValueInJarray(app.event.eventSession, "eventDate", showDate)) {

                                // check event is full or not
                                if (checkValueInJarray(app.allEventSessionList, "eventDate", showDate)) {
                                    date_active = true;
                                    date_class = date_class + "event_date ";
                                }
                                else {
                                    date_active = false;
                                    date_class = date_class + "event_full ";
                                }
                            }
                            
                            return [date_active, date_class, ""]; 
                        },
                        onSelect: function (dateText, inst) {
                            var selectDate = moment(inst.currentYear + "/" + (inst.currentMonth + 1) + "/" + inst.currentDay);
                            app.eventSessionClick(selectDate.format(app.$root.info.api_date_format));
                        }
                    });

                    if (firstSession != null) {
                        calendar_obj.datepicker("setDate", firstSession.format(app.$root.info.common_date_format));                        
                    }
                }
                else {
                    setTimeout(app.initDatePicker, 100);
                }
            },

            getYouMayAlsoLikeList() {
                var app = this;
                var filter_json = {
                    "pagingNo": 1,
                    "pagingSize": 2,
                    "categoryCode": [],
                    "sortBy": "random",
                    "excludeEvent": [app.event.eventId]
                };
                $.each(app.event.category, function (key, cate) {
                    filter_json.categoryCode.push(cate.categoryCode);
                });
                //console.log("filter_json", filter_json);

                /*app.$root.wsPost(app.info.wsUrl + "/Event/GetEventList", app.$root.info.lang, JSON.stringify(filter_json), function (data) {
                    //console.log("getYouMayAlsoLikeList", data);
                    if (data.status == 0) {
                        app.YouMayAlsoLikeList = data.eventList.slice();
                    }
                });*/
                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: (app.info.member == null ? "" : app.info.member.memberToken) },
                    url: app.info.wsUrl + "/Event/GetEventList",
                    async: true,
                    contentType: "application/json",
                    data: JSON.stringify(filter_json),
                    dataType: "json",
                    success: (data) => {
                        //console.log("getYouMayAlsoLikeList", data);
                        if (data.status == 0) {
                            app.YouMayAlsoLikeList = data.eventList.slice();
                        }
                    },
                });

            },

            EventBookNowBtnEnable() {

                if (this.event.allowJoin) {
                    if (this.event.canEnrolment) {

                        if (moment(this.event.eventEndDate) >= moment(moment().format("YYYYMMDD"))) {

                            if (this.event.allSessionFullComplete) {
                                if (this.event.isWaitingList) {
                                    this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_join_waiting_list'];
                                    return true;
                                }
                                else {
                                    this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_event_is_full'];
                                    return false;
                                }
                            }
                            else {
                                if (this.event.allSessionFull) {
                                    this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_event_is_full'];
                                    return false;
                                }
                                else {
                                    if (this.event.maxPrice > 0) {
                                        this.EventBookNowBtnLabel1 = this.label['event_details_text_booknow_details'];
                                        this.EventBookNowBtnLabel2 = this.label['event_details_text_booknow_order'];
                                        return true;
                                    }
                                    else {
                                        //this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_join_free_event'];
                                        this.EventBookNowBtnLabel1 = this.label['event_details_text_join_free_event_details'];
                                        this.EventBookNowBtnLabel2 = this.label['event_details_text_join_free_event_order'];
                                        return true;
                                    }
                                }
                            }

                        }
                        else {
                            this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_enrolment_date_is_over'];
                            return false;
                        }

                    }
                    else {
                        this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_enrolment_date_is_over'];
                        return false;
                    }
                }
                else {
                    this.EventBookNowBtnLabel1 = this.EventBookNowBtnLabel2 = this.label['event_details_text_no_permission'];
                    return false;
                }
            },

            initOpenTnc() {
                var app = this;
                var tnc = app.$root.getParameterByName("tnc");
                if (tnc != null) {
                    if (tnc == "true")
                        window.setTimeout(function () { app.openEventTNC(); }, 500);

                    //window.history.replaceState(null, null, ("/" + app.info.lang + app.info.currentPathName));
                }
            },
            initOpenEventClick() {
                var app = this;
                var init = app.$root.getParameterByName("init");
                if (init != null) {
                    if (init == "c")
                        window.setTimeout(function () { app.FirstBookingBtnClick(false); }, 500);

                    //window.history.replaceState(null, null, ("/" + app.info.lang + app.info.currentPathName));
                }
            },
            ConfirmationMessageClick(no) {
                if (no == 1) {
                    if (this.isConfirmationMessage)
                        this.isConfirmationMessage = false;
                    else
                        this.isConfirmationMessage = true;
                }
                else if (no == 2) {
                    if (this.isConfirmationMessage_2)
                        this.isConfirmationMessage_2 = false;
                    else
                        this.isConfirmationMessage_2 = true;
                }
                else if (no == 3) {
                    if (this.isConfirmationMessage_3)
                        this.isConfirmationMessage_3 = false;
                    else
                        this.isConfirmationMessage_3 = true;
                }
            },

        },
    };
</script>
